import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';

// Create Ticket Category
export const createTicketCategory = createAsyncThunk(
  'ticketCategory/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/ticket-categories', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create ticket category');
    }
  }
);

// Fetch Ticket Category by ID
export const fetchTicketCategoryById = createAsyncThunk(
  'ticketCategory/fetchById',
  async (categoryId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/ticket-categories/${categoryId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch ticket category');
    }
  }
);

// Fetch All Ticket Categories
export const fetchTicketAllCategories = createAsyncThunk(
  'ticketCategory/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/ticket-categories');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch ticket categories');
    }
  }
);
export const fetchTicketCategorySummary = createAsyncThunk(
    'Ticket/fetchTicketCategorySummary',
    async (_, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.get('/ticket-category-summary');
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to fetch Ticket Category');
      }
    }
  );

// Update Ticket Category
export const updateTicketCategory = createAsyncThunk(
  'ticketCategory/update',
  async ({ categoryId, ...data }: any & { categoryId: number }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/ticket-categories/${categoryId}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update ticket category');
    }
  }
);

// Delete Ticket Category
export const deleteTicketCategory = createAsyncThunk(
  'ticketCategory/delete',
  async (categoryId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.delete(`/ticket-categories/${categoryId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete ticket category');
    }
  },
);

// Fetch Ticket Category Summary by Department
export const fetchTicketCategorySummaryByDepartment = createAsyncThunk(
  'ticketCategory/fetchSummaryByDepartment',
  async (departmentId: string, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/ticket-category-summary/${departmentId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch category summary by department');
    }
  }
);
